import React from 'react';
import LinkButton from './LinkButton.jsx'

class Button extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        if (!this.props.onClick) {
            return;
        }
        if (event) {
            event.preventDefault();
        }
        this.props.onClick(this.props.name);
    }

    render() {
        let className = 'btn';
        if (this.props.config) {
            for (let id in this.props.config) {
                const value = this.props.config[id];
                if (!value) {
                    continue;
                }
                className += ` btn--${value}`;
            }
        }
        if (this.props.form) {
            className += ' form__btn';
        }
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }
        if (this.props.link) {
            return (
                <a href={this.props.link} className={className} style={this.props.style} target={this.props.target}>
                    {this.props.children}
                </a>
            );
        } else if (this.props.renderAsLink) {
            return (
                <a href="#" className={className} style={this.props.style} onClick={this.handleClick}>
                    {this.props.children}
                </a>
            );
        }
        const buttonProps = {
            className: className,
            name: this.props.name,
            style: { cursor: 'pointer' },
            type: this.props.type,
            onClick: this.handleClick
        };
        if (this.props.disabled) {
            buttonProps.disabled = true;
            buttonProps.style = { cursor: 'not-allowed' };
        }
        return (
            <button {...buttonProps}>
                {this.props.children}
            </button>
        );
    }
}

class Follow extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.props.onChange) {
            this.props.onChange(this.props.data);
        }
    }

    render() {
        let className, content, label;
        if (this.props.type == 'like') {
            className = 'art__like';

            let favoriteClassName = 'i i--heart';
            let favoriteStyle;
            if (this.props.data && this.props.data.IsFavorite) {
                favoriteClassName += ' isfavorite';
                favoriteStyle = { color: '#f33' };
            }
            content = <span className={favoriteClassName} style={favoriteStyle} />;
            label = `Like ${this.props.data.Title}`;
        } else if (this.props.type == 'list') {
            className = 'art__list';
            let favoriteClassName = 'i i--plus';
            content = <span className={favoriteClassName} />;
        } else {
            let display;
            className = 'btn btn--follow';
            if (this.props.data && this.props.data.IsFollowing) {
                className += ' btn--follow--active';
                display = 'Following';
            } else {
                className += ' text--change';
                display = 'Follow';
            }
            content = (
                <React.Fragment>
                    <span className="btn--follow__icon">
                        <span className="i i--plus"></span>
                    </span>
                    <span className="btn--follow__text">{display}</span>
                </React.Fragment>
            );
            label = `Follow ${this.props.data.Company || this.props.data.Name || ''}`;
        }
        return (
            <a href="#" className={className} onClick={this.handleChange} aria-label={label}>
                {content}
                {this.props.children}
            </a>
        );
    }
}

function Text(props) {
    return <Button {...props}><span className="btn__text">{props.children}</span></Button>
}

export {
    Button,
    Follow,
    LinkButton,
    Text
};